module.exports = __webpack_public_path__ + "static/media/onion.91589f21.jpg";